import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    // minHeight: "100vh",
    padding: "2rem",
  }
})